<mat-form-field class="flex-100">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [disabled]="disabled"
    [errorStateMatcher]="matcher"
    (focusout)="onFocusOut()"
    (input)="onInput($event)"
    [required]="required"
    [type]="type"
    [value]="value"
  />
  <mat-icon matSuffix (click)="onVisibilityClick($event)">{{ icon }}</mat-icon>
  @if (ngControl.hasError('required')) {
    <mat-error>{{ label }} is a required field.</mat-error>
  }
  @if (ngControl.hasError(customErrorName)) {
    <mat-error>{{ customErrorMessage }}</mat-error>
  }
</mat-form-field>
